import { render, staticRenderFns } from "./ExchangeBill.vue?vue&type=template&id=4c44bbca&scoped=true"
import script from "./ExchangeBill.vue?vue&type=script&lang=js"
export * from "./ExchangeBill.vue?vue&type=script&lang=js"
import style0 from "./ExchangeBill.vue?vue&type=style&index=0&id=4c44bbca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c44bbca",
  null
  
)

export default component.exports